import cls from "./Cookie.module.scss";
import Title, {TitleTheme} from "shared/ui/Title/Title";
import Paragraph from "shared/ui/Paragraph/Paragraph";
import {classNames} from "shared/lib/classNames/classNames";
import Button, {ButtonTheme} from "shared/ui/Button/Button";


interface CookieProps {
    className?: string;
    onAccept?: () => void;
    onDecline?: () => void;
}

export const Cookie = ({className, onAccept, onDecline}: CookieProps) => {
    return (
        <div className={classNames(cls.Cookie, {}, [className])}>
            <Title sentences={["Cookie Policy"]} colors={[TitleTheme.NEUTRAL]} className={cls.Cookie__title}/>
            <Paragraph className={"preWrap"}>
                {`First Party Performance and Functionality Cookies.\n\nThese cookies help us to customize and enhance your online experience with Adjet Limited. For example, they help us to remember your preferences and prevent you from needing to re-enter information you previously provided (for example, during applying form).  Deletion of these types of cookies may result in limited functionality of our service.\n\nMost cookies are only active for one day. Some cookies are active for a longer time, ranging from 3 to 12 months.`}
            </Paragraph>

            <div className={cls.Cookie__buttons}>
                <Button theme={ButtonTheme.SECONDARY} onClick={onDecline}>Don`t allow</Button>
                <Button theme={ButtonTheme.PRIMARY} onClick={onAccept}>Allow</Button>
            </div>
        </div>
    )
}
